<template>
  <div>
    <c-list-group class="list-group-accent">
      <c-list-group-item
        class="list-group-item-accent-secondary bg-light
            font-weight-bold text-muted text-uppercase small text-left"
      >
        Plugin Updates
        <c-button
          v-if="siteUpdates.length"
          class="float-right"
          color="secondary"
          size="sm"
          @click="clearSiteNotifications"
        >
          Clear
        </c-button>
      </c-list-group-item>
    </c-list-group>

    <c-list-group-item
      v-for="(site, i) in siteUpdates"
      :key="`${i}_site`"
      class="list-group-item-accent-success list-group-item-divider"
    >
      <div class="text-uppercase mb-1">
        <small><strong v-html="site.name" /></small>
      </div>
      <c-progress class="progress-xs" color="info" :value="site.pluginUpdatesRemainingPercentage" />
      <small class="text-muted">
        {{ site.pluginUpdatesRemainingPercentage < 100 ? 'Updating plugins' : 'Update complete' }}
        <span class="float-right mt-1">{{ site.pluginUpdatesRemainingPercentage }}%</span>
      </small>

      <ul class="mt-3" style="list-style-type: none; font-size: 10px; padding-left: 0px">
        <li v-for="(item, i) in site.messages" :key="`${i}_message`" class="py-1">
          <small class="text-muted">
            <template v-if="pluginUpdateActions.indexOf(item.action) !== -1">
              <c-icon v-if="!item.status" class="mr-2" name="cil-warning" />
              <c-icon v-if="item.status" class="mr-2" name="cil-check" />
            </template>
            <c-icon v-else class="mr-2" name="cil-chevron-right" />
          </small>
          <span class="text-muted" v-html="item.actionDisplay" />
        </li>
      </ul>
    </c-list-group-item>

    <!--    <div>-->
    <!--      <a v-if="siteUpdates.length" @click="clearSiteNotifications" class="button is-small is-primary clear-notifications">Clear</a>-->
    <!--      <div class="header">-->
    <!--        <h2 class="title is-3">Notifications</h2>-->
    <!--        <h2 v-if="!siteUpdates.length" class="title is-4 no-notifications">You're all up to date <i class="fa fa-smile-o"></i></h2>-->
    <!--      </div>-->

    <!--      <template v-for="site in siteUpdates">-->
    <!--        <div class="title is-4 site-name">-->
    <!--          <router-link v-html="site.name" :to="{name: 'detailsSite', params: {siteId: site.siteId}}"></router-link>-->
    <!--          <div class="update-info" v-if="!site.updateQueued">-->
    <!--            <span class="update-percentage">{{site.pluginUpdatesRemainingPercentage}}%</span>-->
    <!--            <i v-if="site.pluginUpdatesRemainingPercentage < 100" class="update-animation fa fa-refresh fa-spin fa-fw"></i>-->
    <!--            <template v-else>-->
    <!--              <i v-if="site.pluginUpdatesErrorCount > 0" class="fa fa-exclamation-circle"> </i>-->
    <!--              <i v-else class="fa fa-check"> </i>-->
    <!--            </template>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <div class="is-clearfix"></div>-->
    <!--        <ul>-->
    <!--          <li v-for="item in site.messages">-->
    <!--            <template v-if="pluginUpdateActions.indexOf(item.action) !== -1">-->
    <!--              <i v-if="!item.status" class="fa fa-exclamation-circle" aria-hidden="true"> </i>-->
    <!--              <i v-if="item.status" class="fa fa-check" aria-hidden="true"> </i>-->
    <!--            </template>-->
    <!--            <i v-else class="fa fa-chevron-right" aria-hidden="true"></i>-->
    <!--            <span v-html="item.actionDisplay"></span>-->
    <!--          </li>-->
    <!--        </ul>-->
    <!--      </template>-->
    <!--    </div>-->
  </div>

  <!--  <aside class="menu app-notifications animated" :class="{ slideInRight: show, slideOutRight: !show }">-->
  <!--  </aside>-->
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  sockets: {},
  components: {},

  props: {
    show: Boolean,
  },

  data() {
    return {
      sites: [],
      pluginUpdateActions: ['plugin-update-error', 'plugin-update-success'],
    };
  },
  created() {},

  computed: {
    ...mapGetters({
      siteUpdates: 'siteUpdates',
    }),
  },

  // computed: {
  //   siteUpdates () {
  //     return this.$store.state.siteUpdates
  //   }
  // },

  methods: {
    ...mapActions({
      clearSiteNotifications: 'clearSiteNotifications',
    }),
  },
};
</script>

<style lang="scss" scoped="scoped">
//@import '~bulma/sass/utilities/variables';
//@import '~bulma/sass/utilities/mixins';

//.auth {
//  .app-notifications {
//    display: none;
//  }
//}
//
//.app-notifications {
//  .clear-notifications {
//    float: right;
//  }
//  .header {
//    margin-bottom: 20px;
//    h2 {
//      color: white;
//      &.no-notifications {
//        margin-top: 50px;
//        text-align: center;
//      }
//    }
//  }
//  .site-name {
//    font-weight: bold;
//    color: white;
//    a {
//      width: 70%;
//      float: left;
//    }
//    .update-info {
//      float: right;
//    }
//  }
//  ul {
//    margin-top: 20px;
//    margin-bottom: 20px;
//  }
//  p, li, a:not(.button) {
//    color: white;
//  }
//  li {
//    font-size: 14px;
//    margin-bottom: 5px;
//    i {
//      margin-top: 4px;
//    }
//  }
//  background-color: #00d1b2;
//  position: fixed;
//  top: 50px;
//  right: 0;
//  bottom: 0;
//  padding: 10px;
//  width: 350px;
//  min-width: 45px;
//  max-height: 100vh;
//  height: calc(100% - 50px);
//  z-index: 1024 - 1;
//  box-shadow: 0 2px 3px rgba(17, 17, 17, 0.1), 0 0 0 1px rgba(17, 17, 17, 0.1);
//  overflow-y: auto;
//  overflow-x: hidden;
//  transform: translate3d(180px, 0, 0);
//}
</style>
